import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class AccountRate extends AppRecord {
  resetMomerizedComputed(){
    this._account_name = undefined
    this._bank = undefined
  }
  get account(){
    return this.constructor.employeeStore.accountsById.get(this.account_id)
  }
  get account_name(){
    if(this._account_name){return this._account_name}
    if(this.account){
      return this._account_name = this.account.name
    } else {
      return undefined
    }
  }
  get bank(){
    if(this._bank){return this._bank}
    if(this.account){
      let bank = this.constructor.employeeStore.banks.find(bank => bank.id === this.account.bank_id)
      if(bank) {
        return this._bank = bank.name
      } else {
        return this._bank = null
      }
    } else {
      return undefined
    }
  }
  get entity_long_name(){
    if(this._entity_long_name){return this._entity_long_name}
    if(this.account && this.account.entity){
      this._entity_long_name = this.account.entity.long_name
      return this._entity_long_name
    } else {
      return undefined
    }
  }
  get entity(){
    if(this.account_id && this.account){
      return this.account.entity
    } else {
      return this._entity
    }
  }
  set entity(new_entity){
    this.update({account_id: null, _entity: new_entity})
  }
}

export default AccountRate
